import React, { useEffect, useState } from "react";
import { Table, Button, Container, Form, Row, Col, Modal,Pagination } from "react-bootstrap";
import { Link, useHistory } from 'react-router-dom';
import {Navbar,NavDropdown} from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import sage from "../../../images/splash/sage.jpeg";
import { var_api } from "../../constant";
import axios from "axios";
import Swal from "sweetalert2";


const FeedbackTable = () => {
  const [show, setShow] = useState(false); // Controls the popup visibility
  const [reply, setReply] = useState(""); // Stores the reply text
  const [currentFeedback, setCurrentFeedback] = useState(null); // Tracks the selected feedback for replying
  const history = useHistory();
const [feedbackData, setFeedbackData] = useState([]);
const [reviews, setReviews] = useState([]);
const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5; // Number of rows per page

  // Filter data based on the search term
  const filteredData = feedbackData.filter(
    (item) =>
      item.email_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.mobile_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(item.review_rate)?.toLowerCase().includes(searchTerm.toLowerCase()) ||

      item.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate pagination
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getReviews = async () => {
    // setLoading(true);
    const tokens = localStorage.getItem("token");

    try {
      const response = await axios.get(`${var_api}/api/service-review/booking-reviews`, {
        headers: {
          Authorization: `${tokens}`,
        },
      });
      
      setFeedbackData(response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login
        const redirect = "/login";
        window.location.href = redirect;
      } else {
        console.error(error);
      }
    } 
  };

   // Call getReviews in useEffect
   useEffect(() => {
    getReviews();
  }, []);
  // Filter feedback data based on the search term
  // const filteredFeedback = feedbackData.filter(
  //   (item) =>
  //     item.email_id.toLowerCase().includes(item.email_id.toLowerCase()) ||
  //     item.description.toLowerCase().includes(item.description.toLowerCase())
  // );

  const handleReplyClick = (feedback) => {
    setCurrentFeedback(feedback);
    setReply(feedback.shop_reply || ""); // Prefill the reply if it exists
    setShow(true); // Show the popup
  };

  const handleClose = () => setShow(false); // Close the popup

  // Handle updating the reply
  const handleUpdateReply = async () => {
    if (!currentFeedback) return;

    const tokens = localStorage.getItem("token");

    try {
      const response = await axios.put(
        `${var_api}/api/service-review/admin-put/${currentFeedback.id}`,
        {
          shop_reply: reply,
        },
        {
          headers: {
            Authorization: `${tokens}`,
          },
        }
      );

      if (response.status === 200) {
        // Update the feedback data locally
        Swal.fire({
          title: "Reply Updated!",
          text: "The reply has been successfully updated.",
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
        });

       console.log("U")
       getReviews();
        setShow(false); // Close the popup
      }
    } catch (error) {
      console.error("Error updating reply:", error);
      // Show a toast or error notification
      alert("Failed to update reply. Please try again.");
    }
  };

  const handleButtonClick = () => {
    history.push('/home');
  };


  const handleShop = async()=>{
    setShow(true);

  }
  return (
    <>  
           <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       SHOP REVIEW MASTER
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
    <Container
      fluid
      style={{
        padding: "30px 50px",
        backgroundColor: "#f8f9fa",
        width: "95%",
        marginTop:"50px",
        maxWidth: "1200px",
        // margin: "auto",
        marginTop:"90px",
        minHeight: "90vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
     
      <Row className="align-items-center">
        <Col>
          {/* Removed the heading */}
        </Col>
        <Col xs="auto">
        <Form.Control
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setCurrentPage(1); // Reset to first page on new search
        }}
        size="sm"
        style={{ width: "250px", marginBottom: "15px" }}
      />
        </Col>
      </Row>
      <Row className="justify-content-center flex-grow-1">
        <Col xs={12}>
        <Table
            striped
            bordered
            hover
            responsive="sm"
            style={{
              backgroundColor: "#fff", // Default table background color removed
              borderRadius: "10px", // Keep the border radius
              padding: "15px", // Keep padding as is
              height: "100%",
              minHeight: "500px",
              boxShadow: "none", // Removed box shadow
            }}
          >
        <thead>
          <tr>
            <th style={{ textAlign: "center", verticalAlign: "middle" }}>S. No.</th>
            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Email ID</th>
            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Mobile No.</th>
            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Rating</th>
            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Description</th>
            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Shop Reply</th>
            <th style={{ textAlign: "center", verticalAlign: "middle" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentData.map((item, index) => (
            <tr key={index}>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                {indexOfFirstRow + index + 1}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                {item.email_id}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                {item.mobile_no}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                {item.review_rate}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                {item.description}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                {item.shop_reply || ""}
              </td>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => handleReplyClick(item)}
                >
                  Reply
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Pagination */}
      <Pagination className="justify-content-end">
        {[...Array(totalPages)].map((_, pageIndex) => (
          <Pagination.Item
            key={pageIndex + 1}
            active={currentPage === pageIndex + 1}
            onClick={() => handlePageChange(pageIndex + 1)}
          >
            {pageIndex + 1}
          </Pagination.Item>
        ))}
      </Pagination>
        </Col>
      </Row>

      {/* Popup Modal */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Give Reply</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Reply</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your reply"
              value={reply}
              onChange={(e) => setReply(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-start">
          <Button
            variant="secondary"
            style={{ backgroundColor: "green", color: "white" }}
            onClick={handleUpdateReply}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
    </>
  );
};

export default FeedbackTable;
